import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=a8e6f85c&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=a8e6f85c&scoped=true&lang=css&"
import style1 from "./DataTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e6f85c",
  null
  
)

export default component.exports